import { PieChart } from '@tamagui/lucide-icons';
import { PortfolioOverview } from '@unistocks/features/dashboard/components/dashboard-data/portfolio-overview/portfolio-overview';
import { queryFilter } from '@unistocks/features/dashboard/components/dashboard-data/portfolio-overview/query-filter';
import {
  PortfolioOverviewSettings,
  portfolioOverviewSchemaFactory
} from '@unistocks/features/dashboard/components/dashboard-data/portfolio-overview/settings';
import { DashboardItemDescriptor } from '@unistocks/features/dashboard/dashboard-item-descriptor';
import { PieChartType } from '@unistocks/proxy/axios-client';

export const dashboardItemDescriptor: DashboardItemDescriptor = {
  component: PortfolioOverview,
  settingsSteps: [PortfolioOverviewSettings],
  schemaFactory: portfolioOverviewSchemaFactory,
  defaults: setValue => {
    setValue('pieChartSettings', { chartType: PieChartType.Categories });
  },
  queryFilter: queryFilter,
  icon: PieChart
};
